import React from 'react';
import { ArrowDownIcon } from 'lucide-react';
import { Reveal } from '../Reveal';
import { useLanguage } from '../../contexts/LanguageContext';
export function Process() {
  const {
    t
  } = useLanguage();
  const steps = t.process.steps;
  return <section id="process" className="bg-mist py-24 sm:py-32" aria-labelledby="process-heading" data-id="element-250" data-mp="p1yqekart7pu">
      <div className="mx-auto max-w-shell px-5 sm:px-8" data-id="element-251" data-mp="k4gfiod70if7">
        <Reveal data-id="element-252" data-mp="3sip5rps8sx47">
          <div className="mx-auto max-w-[720px] text-center" data-id="element-253" data-mp="3sk8mfhht9a6i">
            <p className="text-[12px] font-semibold uppercase tracking-[0.2em] text-brand" data-id="element-254" data-mp="3nkniesnsabmx">
              {t.process.eyebrow}
            </p>
            <h2 id="process-heading" className="headline mt-5 text-[32px] font-bold text-ink sm:text-[46px]" data-id="element-255" data-mp="65gstm98qdlo">
              {t.process.heading}
            </h2>
          </div>
        </Reveal>

        <ol className="mx-auto mt-16 max-w-[820px]" data-id="element-256" data-mp="39ro60zjasxjl">
          {steps.map((step, i) => <li key={step.title} data-id="element-257" data-mp="34unz6memjqrf" data-mpi={i}>
              <Reveal delay={i * 0.06} data-id="element-258" data-mp="34tmcfko8xftv">
                <div className="group flex flex-col gap-5 rounded-3xl border border-ink/[0.07] bg-white p-7 shadow-soft transition-all duration-300 hover:-translate-y-1 hover:border-brand/25 hover:shadow-lift sm:flex-row sm:items-center sm:gap-8 sm:p-8" data-id="element-259" data-mp="2ms1wpnp2p85b">
                  <span className="flex h-14 w-14 shrink-0 items-center justify-center rounded-2xl bg-ink text-[18px] font-bold text-white transition-colors duration-300 group-hover:bg-brand" data-id="element-260" data-mp="2wi4xia2frqe7">
                    {i + 1}
                  </span>
                  <div className="flex-1" data-id="element-261" data-mp="28rr34cwdpfgg">
                    <p className="text-[11px] font-semibold uppercase tracking-[0.18em] text-brand" data-id="element-262" data-mp="28skfpui0qz6i">
                      {step.step}
                    </p>
                    <h3 className="mt-2 text-[21px] font-semibold tracking-tight text-ink" data-id="element-263" data-mp="2ht8i1ry1vb3k">
                      {step.title}
                    </h3>
                    <p className="mt-2 text-[15px] leading-relaxed text-ink/60" data-id="element-264" data-mp="3o8j9u1uswunr">{step.body}</p>
                  </div>
                </div>
              </Reveal>
              {i < steps.length - 1 && <Reveal delay={i * 0.06 + 0.05} data-id="element-265" data-mp="1t41nux5e3u3q">
                  <div className="flex justify-center py-3" aria-hidden="true" data-id="element-266" data-mp="1p4b1r6qt625j">
                    <span className="flex h-9 w-9 items-center justify-center rounded-full border border-ink/10 bg-white/70 shadow-soft backdrop-blur" data-id="element-267" data-mp="1p6donhwnzf61">
                      <ArrowDownIcon className="h-4 w-4 text-ink/45" data-id="element-268" data-mp="1y5qyibopa5ra" />
                    </span>
                  </div>
                </Reveal>}
            </li>)}
        </ol>
      </div>
    </section>;
}